var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo, useState } from "react";
import { DialogContainer, FTLAvatar, FTLDivider, FTLDropdownMenuWithController, FTLHeader, FTLIconButton, FTLMobileMenu, FTLSideMenu, SnackbarContainer, } from "ftl-uikit";
import { Box, ListItem, ListItemText, makeStyles, List, useMediaQuery, } from "@material-ui/core";
import { dialogService, handleError, useGlobalStoreState } from "ftl-core";
import { useHistory } from "react-router-dom";
const ProfileListItem = ({ onClick, label, disabled, key }) => {
    const classes = useStyles();
    return (_jsx(ListItem, Object.assign({ button: true, disabled: disabled, className: classes.listItem, onClick: onClick }, { children: _jsx(ListItemText, Object.assign({ className: classes.listItemText }, { children: label }), void 0) }), key));
};
const ProfileList = ({ profileMenuItems, onMenuItemClick, history, }) => {
    const components = useMemo(() => profileMenuItems.map((item) => {
        if (item.type === "divider")
            return _jsx(FTLDivider, { margin: 2 }, void 0);
        return (_jsx(ProfileListItem, { onClick: () => {
                if (typeof item.to === "object") {
                    history.push(item.to.pathname || "", item.to.state);
                }
                else if (typeof item.to === "string")
                    history.push(item.to);
                else if (item.onClick)
                    item.onClick();
                onMenuItemClick();
            }, disabled: item.disabled, label: item.label }, item.label));
    }), [profileMenuItems]);
    return _jsx(List, { children: components }, void 0);
};
export default ({ style, children, onSignOut, title, sideMenuItems = [], profileMenuItems: profileMenuItemsFromProps = [], disableDefaultProfileMenuItems = false, toHomeUrl, AuthClient, logo, onMenuClick, }) => {
    const desktop = useMediaQuery((theme) => theme.breakpoints.up("md"));
    const [sideMenuWidth, setSideMenuWidth] = useState(245);
    const { profile } = useGlobalStoreState();
    const history = useHistory();
    const profileHasData = Boolean(profile === null || profile === void 0 ? void 0 : profile.id);
    const profileMenuItems = useMemo(() => disableDefaultProfileMenuItems ? [
        ...profileMenuItemsFromProps,
        { type: "divider" },
        {
            label: "Выйти",
            needHighlight: false,
            onClick: () => {
                dialogService.show({
                    title: "Смена аккаунта",
                    onSubmit: onSubmitDialog,
                    children: "Вы действительно хотите выйти из данной учётной записи?",
                });
            },
        },
    ] : [
        {
            label: "Личные данные",
            to: { pathname: "/profile", state: { tabIndex: 0 } },
            disabled: !profileHasData,
            needHighlight: false,
        },
        {
            label: "Контактные данные",
            to: { pathname: "/profile", state: { tabIndex: 1 } },
            disabled: !profileHasData,
            needHighlight: false,
        },
        {
            label: "Безопасность",
            to: { pathname: "/profile", state: { tabIndex: 2 } },
            disabled: !profileHasData,
            needHighlight: false,
        },
        ...profileMenuItemsFromProps,
        { type: "divider" },
        {
            label: "Выйти",
            needHighlight: false,
            onClick: () => {
                dialogService.show({
                    title: "Смена аккаунта",
                    onSubmit: onSubmitDialog,
                    children: "Вы действительно хотите выйти из данной учётной записи?",
                });
            },
        },
    ], [profileMenuItemsFromProps, profileHasData, disableDefaultProfileMenuItems]);
    const onSubmitDialog = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield AuthClient.signOut();
            if ("serviceWorker" in navigator) {
                caches.keys().then(function (keyList) {
                    return Promise.all(keyList.map((key) => {
                        if (key.search(/v2/) === -1) {
                            return caches.delete(key);
                        }
                        return null;
                    }));
                });
            }
            history.push("/");
            onSignOut && onSignOut();
        }
        catch (error) {
            handleError({
                error,
                defaultError: "Произошла ошибка при выходе из учетной записи",
            });
        }
        dialogService.close();
    }), [onSignOut]);
    const [open, setOpen] = useState(false);
    const classes = useStyles();
    return (_jsxs(React.Fragment, { children: [_jsx(FTLHeader, Object.assign({ logo: logo, logoLink: toHomeUrl, title: title }, { children: desktop ? (_jsx(FTLDropdownMenuWithController, Object.assign({ open: open, onClose: () => setOpen(false), onOpen: () => {
                        onMenuClick && onMenuClick();
                        setOpen(true);
                    }, placement: "bottom-end", className: classes.listContainer, controller: _jsx(FTLIconButton, Object.assign({ disableRipple: true }, { children: _jsx(FTLAvatar, { type: "avatar", src: profile === null || profile === void 0 ? void 0 : profile.profileImageUrl, size: "xsmall" }, void 0) }), void 0), disableMargin: true, hideOnMenuClick: true }, { children: _jsx(ProfileList, { profileMenuItems: profileMenuItems, onMenuItemClick: () => setOpen(false), history: history }, void 0) }), void 0)) : (_jsx(FTLMobileMenu, { open: open, onOpen: () => {
                        onMenuClick && onMenuClick();
                        setOpen(true);
                    }, onClose: () => {
                        setOpen(false);
                    }, items: [...sideMenuItems, { type: "divider" }, ...profileMenuItems] }, void 0)) }), void 0), _jsxs(Box, Object.assign({ width: "100%", height: "100%", display: "flex" }, { children: [desktop && (_jsx(FTLSideMenu, { onMinimize: (width) => {
                            setSideMenuWidth(width);
                        }, items: sideMenuItems }, void 0)), _jsx(Box, Object.assign({ display: "flex", width: "100%", flexGrow: "1", maxHeight: "calc(100vh - 56px)", overflow: "hidden auto", style: style }, { children: _jsxs("div", Object.assign({ className: classes.layout }, { children: [children, _jsx(SnackbarContainer, { style: desktop
                                        ? {
                                            marginLeft: sideMenuWidth / 2,
                                            transition: "margin-left 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                                        }
                                        : {} }, void 0), _jsx(DialogContainer, {}, void 0)] }), void 0) }), void 0)] }), void 0)] }, void 0));
};
const useStyles = makeStyles((theme) => ({
    layout: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        paddingRight: theme.spacing(10),
        paddingLeft: theme.spacing(10),
        marginTop: theme.spacing(6),
        [theme.breakpoints.down("sm")]: {
            paddingRight: theme.spacing(5),
            paddingLeft: theme.spacing(5),
        },
    },
    link: {
        display: "flex",
        textDecoration: "none",
    },
    listContainer: {
        minWidth: 192,
        marginTop: 4,
    },
    listItem: {
        padding: "6px 12px",
    },
    listItemText: {
        margin: 0,
        "& > span": Object.assign({}, theme.typography.listItemText),
    },
}));
//# sourceMappingURL=FTLBaseLayout.js.map